import { render, staticRenderFns } from "./WatchRecordedInfoCard.vue?vue&type=template&id=1be6e49b"
import script from "./WatchRecordedInfoCard.vue?vue&type=script&lang=ts"
export * from "./WatchRecordedInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports